import { render, staticRenderFns } from "./IntakeQuestions.vue?vue&type=template&id=485e5c3d&"
import script from "./IntakeQuestions.vue?vue&type=script&lang=js&"
export * from "./IntakeQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports